import { actions } from './actions'

const initialState = {
  historialStocks: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function historialStocksReducer(state = initialState, action) {
  switch (action.type) {
    case actions.HISTORIAL_STOCKS_LOAD_REQUESTED:
      return { ...state, historialStocks: { ...state.historialStocks, loading: true } }
    case actions.HISTORIAL_STOCKS_LOAD_SUCCEEDED:
      return {
        ...state,
        historialStocks: { ...state.historialStocks, data: action.payload, loading: false },
      }
    case actions.HISTORIAL_STOCKS_LOAD_FILED:
      return {
        ...state,
        historialStocks: { ...state.historialStocks, loading: false, error: action.error },
      }
    case actions.HISTORIAL_STOCK_UPDATE_REQUESTED:
      return {
        ...state,
        historialStocks: { ...state.historialStocks, loading: true, error: '' },
      }
    case actions.HISTORIAL_STOCK_UPDATE_SUCCEEDED:
      return {
        ...state,
        historialStocks: {
          ...state.historialStocks,
          data: state.historialStocks.data.map(historial =>
            historial.id === action.payload.id ? action.payload : historial,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.HISTORIAL_STOCK_UPDATE_FILED:
      return {
        ...state,
        historialStocks: { ...state.historialStocks, loading: false, error: action.error },
      }
    case actions.HISTORIAL_STOCK_INSERT_REQUESTED:
      return {
        ...state,
        historialStocks: { ...state.historialStocks, loading: true, error: '' },
      }
    case actions.HISTORIAL_STOCK_INSERT_SUCCEEDED:
      return {
        ...state,
        historialStocks: {
          ...state.historialStocks,
          data: [].concat(action.payload, state.historialStocks.data),
          loading: false,
          error: '',
        },
      }
    case actions.HISTORIAL_STOCK_INSERT_FILED:
      return {
        ...state,
        historialStocks: { ...state.historialStocks, loading: false, error: action.error },
      }
    case actions.HISTORIAL_STOCK_DELETE_REQUESTED:
      return {
        ...state,
        historialStocks: { ...state.historialStocks, loading: true, error: '' },
      }
    case actions.HISTORIAL_STOCK_DELETE_SUCCEEDED:
      return {
        ...state,
        historialStocks: {
          ...state.historialStocks,
          data: state.historialStocks.data.filter(historial => historial.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.HISTORIAL_STOCK_DELETE_FILED:
      return {
        ...state,
        historialStocks: { ...state.historialStocks, loading: false, error: action.error },
      }
    default:
      return state
  }
}
